import { cloneElement, Fragment } from 'react';

import { NumberValueFormatter } from '@gogame/intl-ts';

const PieValueFormatter = ({
  formatter,
  value,
  percent,
  labelType,
  shot = false,
}) => {
  const formattedValue = formatter
    ? cloneElement(formatter, {
        value: value,
      })
    : value;

  const formattedPercent = (
    <NumberValueFormatter.Percent value={percent * 100} precision={2} />
  );

  if (shot) {
    return labelType === 'value' ? formattedValue : formattedPercent;
  } else {
    const order =
      labelType === 'value'
        ? [formattedValue, formattedPercent]
        : [formattedPercent, formattedValue];
    return (
      <Fragment>
        {order[0]} ({order[1]})
      </Fragment>
    );
  }
};

export default PieValueFormatter;
